import { z } from 'zod';

/**
 * Validates that a connection_id matches the expected format:
 * - Starts with "conn_"
 * - Followed by 32 lowercase hexadecimal characters
 * - Total length of 37 characters (e.g., conn_019adcf7900c272278a54152dfc2a913)
 */
export function isValidConnectionId(connectionId: string): boolean {
  return /^conn_[a-f0-9]{32}$/.test(connectionId);
}

/**
 * Email form schema for sign-in modals
 */
export const emailFormSchema = z.object({
  email: z
    .string()
    .refine((val) => val === '' || z.string().email().safeParse(val).success, {
      message: 'auth.emailInvalid',
    }),
});

export const iframeSafeAuthRoute = (authUrl: string) => {
  const isIframe = window.top && window.top !== window.self;
  if (isIframe) {
    window.top!.location = authUrl;
  } else {
    window.location.assign(authUrl);
  }
};

export type EmailFormData = z.infer<typeof emailFormSchema>;

/**
 * Validates SSO email format using a safer approach to avoid ReDoS vulnerability.
 * Checks for basic email structure without vulnerable regex backtracking.
 */
export function isValidSsoEmail(email: string): boolean {
  const atIndex = email.indexOf('@');
  const dotIndex = email.lastIndexOf('.');
  return (
    atIndex > 0 &&
    dotIndex > atIndex &&
    dotIndex !== email.length - 1 &&
    !email.includes(' ') &&
    !email.includes('@@')
  );
}
